<template>
  <div class="desktop">
    <div class="d-flex align-center mb-1 flex-wrap" style="gap: 10px">
      <div v-if="!query.knowledge || query.knowledge?.length === 0">
        <p style="font-size: 10px" class="mb-1">View</p>
        <v-card class="pa-1 bg-smokeDark" rounded="lg" flat>
          <v-btn-toggle v-model="mode" mandatory density="compact">
            <v-btn
              v-for="item in viewModes"
              :key="item.value"
              :value="item.value"
              rounded="lg"
            >
              <v-icon size="small" class="mr-2">{{ item.icon }}</v-icon>
              {{ item.text }}
            </v-btn>
          </v-btn-toggle>
        </v-card>
      </div>

      <div
        v-if="
          (mode === 'grid' && !query.knowledge) ||
          query.knowledge?.length === 0 ||
          mode === 'order' ||
          mode === 'calendar'
        "
      >
        <p style="font-size: 10px" class="mb-1 d-flex align-center">
          <v-badge
            v-if="suggestedCategoriesCount > 0"
            :content="suggestedCategoriesCount"
            color="error"
            offset-x="-15"
          >
            <span>Category</span>
          </v-badge>
          <span v-else>Category</span>
        </p>
        <div class="d-flex align-center" style="gap: 8px">
          <v-menu>
            <template v-slot:activator="{ props }">
              <v-btn
                variant="flat"
                color="smokeDark"
                v-bind="props"
                height="44"
                append-icon="mdi-unfold-more-horizontal"
              >
                {{
                  query.category
                    ? categories.find((c) => c.uid === query.category)?.name ||
                      "Uncategorized"
                    : "Uncategorized"
                }}
              </v-btn>
            </template>
            <v-list density="compact">
              <v-list-item
                link
                v-for="c in categories.filter((c) => c.status !== 'suggested')"
                :key="c.uid"
                @click="query.category = c.uid"
              >
                <v-list-item-title>
                  {{ c.name }}
                  <span class="text-muted">
                    ({{ c.counter?.posts || 0 }})
                  </span>
                </v-list-item-title>
                <template v-slot:append>
                  <v-chip
                    class="ml-2"
                    size="x-small"
                    label
                    :color="c.active ? 'success' : 'grey-lighten-1'"
                    variant="flat"
                    style="font-size: 9px"
                  >
                    {{ c.active ? "Active" : "Paused" }}
                  </v-chip>
                </template>
              </v-list-item>
              <v-list-item
                v-if="mode !== 'queue'"
                link
                @click="query.category = null"
              >
                <v-list-item-title>Uncategorized </v-list-item-title>
              </v-list-item>
              <template v-if="suggestedCategoriesCount > 0">
                <v-divider class="my-1" />
                <div class="px-4 py-1">
                  <span
                    style="
                      font-size: 9pt;
                      font-weight: 600;
                      color: #71717a;
                      text-transform: uppercase;
                      letter-spacing: 0.05em;
                    "
                    >Suggested</span
                  >
                </div>
                <v-list-item
                  v-for="c in categories.filter(
                    (c) => c.status === 'suggested',
                  )"
                  :key="'suggested-' + c.uid"
                >
                  <v-list-item-title class="mr-2">
                    {{ c.name }}
                  </v-list-item-title>
                  <template v-slot:append>
                    <KeepCategory :category="c" compact />
                  </template>
                </v-list-item>
              </template>
              <v-divider class="my-1" />
              <NewCategory type="list" />
            </v-list>
          </v-menu>
          <v-btn
            icon
            variant="text"
            color="primary"
            :disabled="!category && suggestedCategoriesCount === 0"
            @click="openCategoryManager(false)"
          >
            <v-icon size="18">mdi-tune-variant</v-icon>
          </v-btn>
        </div>
      </div>

      <div
        v-if="
          (mode === 'grid' && !query.knowledge) || query.knowledge?.length === 0
        "
      >
        <p style="font-size: 10px" class="mb-1">Status</p>
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn
              variant="flat"
              color="smokeDark"
              v-bind="props"
              height="44"
              append-icon="mdi-unfold-more-horizontal"
            >
              {{ getStatusDisplayName(query.status) }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              link
              v-for="status in statusOptions"
              :key="status.value"
              @click="query.status = status.value"
            >
              <v-list-item-title>{{ status.label }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <div v-if="query.knowledge?.length > 0" class="mt-5">
        <v-btn
          variant="flat"
          color="smokeDark"
          @click="query.knowledge = []"
          height="44"
        >
          <v-icon size="14">mdi-close</v-icon>
          Clear filter
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        v-if="hasSuggestedPosts && mode === 'grid'"
        variant="flat"
        color="#18181b"
        class="text-none font-weight-medium text-white mt-5"
        style="border-radius: 6px; letter-spacing: 0"
        height="44"
        :loading="keepingAll"
        @click="keepAllPosts"
      >
        <v-icon size="14" class="mr-1">mdi-check-all</v-icon>
        Keep all suggested posts
      </v-btn>

      <!-- <v-card
        class="pa-1 bg-smokeDark d-flex flex-wrap"
        rounded="lg"
        flat
        v-if="categories.length > 0"
      >
        <v-btn
          v-for="c in categories"
          :key="c.uid"
          :value="c.uid"
          rounded="lg"
          variant="flat"
          :color="query.category === c.uid ? 'buttonGrey' : 'white'"
          @click="query.category = c.uid"
        >
          {{ c.name }}
        </v-btn>
      </v-card> -->

      <!-- <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            v-if="query.category && mode === 'grid'"
            flat
            color="smokeDark"
            :loading="generating_posts"
            class="mt-5"
            height="44"
            prepend-icon="mdi-creation"
            style="
              border-left: 1px solid #272727;
              border-right: 3px solid #272727;
              border-top: 1px solid #272727;
              border-bottom: 3px solid #272727;
              border-radius: 6px;
            "
            >Generate posts</v-btn
          >
        </template>
        <div
          class="bg-smoke"
          style="
            border: 1px solid hsl(214.3 31.8% 91.4%);
            border-radius: 0.5rem;
            box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
          "
        >
          <v-btn-toggle density="compact" class="bg-smoke">
            <v-btn size="small" class="bg-smoke" @click="generatePosts(1)">
              1
            </v-btn>

            <v-btn size="small" class="bg-smoke" @click="generatePosts(2)">
              2
            </v-btn>

            <v-btn size="small" class="bg-smoke" @click="generatePosts(3)">
              3
            </v-btn>

            <v-btn size="small" class="bg-smoke" @click="generatePosts(4)">
              4
            </v-btn>
            <v-btn size="small" class="bg-smoke" @click="generatePosts(5)">
              5
            </v-btn>
          </v-btn-toggle>
        </div>
      </v-menu> -->

      <div v-if="mode === 'calendar'">
        <div
          class="d-flex align-end justify-space-between"
          style="gap: 20px; margin-top: 15px"
        >
          <div class="d-flex justify-center align-center" style="gap: 10px">
            <v-btn
              :disabled="this.$store.state.schedules.window === 0"
              @click="$store.commit('previousWeek')"
              icon
              size="small"
              variant="text"
              ><v-icon>mdi-chevron-left</v-icon></v-btn
            >
            <span style="font-size: 10pt; font-weight: 600; text-align: center"
              >{{ $store.state.schedules.month }}
              {{ $store.state.schedules.year }}</span
            >
            <v-btn
              :disabled="nextWeekDisabled"
              size="small"
              variant="text"
              icon
              @click="$store.commit('nextWeek')"
              ><v-icon>mdi-chevron-right</v-icon></v-btn
            >
            <v-btn variant="tonal" @click="$store.commit('today')">Today</v-btn>
            <v-btn variant="tonal" @click="syncCalendar"
              ><v-icon size="14">mdi-sync</v-icon>Sync calendar</v-btn
            >
          </div>
        </div>
      </div>
    </div>
    <SourcesView v-if="mode === 'articles'" />
    <CalendarView v-else-if="mode === 'calendar'" class="mt-5" />
    <QueueView v-else-if="mode === 'queue'" />
    <div v-else-if="mode === 'order'">
      <div class="d-flex justify-start mt-5 mb-2">
        <v-btn
          size="small"
          variant="outlined"
          class="text-none font-weight-medium shadcn-btn-outline"
          prepend-icon="mdi-shuffle-variant"
          :loading="shuffling"
          @click="shuffleOrder"
        >
          Shuffle order
        </v-btn>
      </div>
      <OrderView :posts="filtered_posts" ref="orderView" />
    </div>
    <div v-else-if="mode === 'grid'">
      <div v-if="!$vuetify.display.smAndDown">
        <!-- <div class="top">
          <v-btn
            @click="$router.push('/post')"
            elevation="0"
            height="42.5"
            class="px-8"
            color="primary"
            ><span class="text-white"><v-icon>mdi-plus</v-icon></span></v-btn
          >

          <v-btn-toggle
            style="height: 42.5px"
            v-model="query.status"
            color="smoke"
            rounded="20"
            group
            mandatory
            :style="{
              borderBottom: '2px solid #272727',
              borderLeft: '0.75px solid #272727',
              borderTop: '0.75px solid #272727',
              borderRight: '2px solid #272727',
            }"
          >
            <v-btn style="font-size: 10pt" value="all"> All </v-btn>

            <v-btn style="font-size: 10pt" value="draft"> Drafts </v-btn>
          </v-btn-toggle>

          <v-select
            label="Category"
            variant="solo"
            style="border-radius: 5px; max-width: 200px"
            :style="{
              borderBottom: '2px solid #272727',
              borderLeft: '0.75px solid #272727',
              borderTop: '0.75px solid #272727',
              borderRight: '2px solid #272727',
            }"
            hide-details=""
            density="compact"
            item-title="name"
            item-value="uid"
            flat
            v-model="query.category"
            :items="categories"
            clearable
          ></v-select>

          <v-text-field
            label="Search posts ..."
            :style="{
              borderBottom: '2px solid #272727',
              borderLeft: '0.75px solid #272727',
              borderTop: '0.75px solid #272727',
              borderRight: '2px solid #272727',
            }"
            flat
            variant="solo"
            density="compact"
            hide-details=""
            style="border-radius: 5px; max-width: 200px"
            v-model="query.search"
            clearable
            @click:clear="clearSearch"
            @change="changeSearch"
          >
          </v-text-field>
        </div> -->

        <div v-if="loading.general">
          <div class="posts">
            <v-skeleton-loader
              type="card"
              v-for="n in 10"
              :key="n"
              width="200"
              height="200"
            ></v-skeleton-loader>
          </div>
        </div>

        <div
          class="posts"
          v-else-if="!loading.posts && filtered_posts.length > 0"
        >
          <div v-for="p in filtered_posts" :key="p.uid">
            <PostsCard :p="p" @delete="deletePost" />
          </div>
        </div>

        <div
          v-else-if="query.status === 'ai'"
          class="mt-4"
          style="display: flex; gap: 20px; flex-direction: column"
        >
          <v-card
            flat
            :style="{
              borderBottom: '3px solid #272727',
              borderLeft: '1px solid #272727',
              borderTop: '1px solid #272727',
              borderRight: '3px solid #272727',
            }"
          >
            <v-data-table :items="suggested_posts"></v-data-table>
          </v-card>
        </div>
        <div v-else-if="filtered_posts.length === 0 && !loading.posts">
          <div
            v-if="accounts.length === 0"
            style="width: 100%; height: calc(100vh - 200px)"
            class="d-flex flex-column align-center justify-center"
          >
            <div>
              <v-img
                :src="require('@/assets/illustrations/1.svg')"
                width="20vw"
                max-width="50px"
              />
            </div>
            <div>
              <p>Connect your LinkedIn account to get started</p>
            </div>
            <v-btn
              variant="flat"
              color="primary"
              class="mt-4"
              @click="$router.push('/brand')"
              >Connect account</v-btn
            >
          </div>
          <div v-else-if="categories.length === 0">
            <div
              class="d-flex flex-column align-center justify-center"
              style="gap: 10px; height: calc(100vh - 200px)"
            >
              <div>
                <v-img
                  :src="require('@/assets/illustrations/2.svg')"
                  width="20vw"
                  max-width="50px"
                />
              </div>
              <p>No categories found</p>
              <v-btn
                variant="flat"
                color="primary"
                @click="$router.push('/categories')"
                >Create a category</v-btn
              >
            </div>
          </div>

          <div
            v-else
            style="width: 100%; height: calc(100vh - 200px)"
            class="d-flex flex-column align-center justify-center"
          >
            <!-- <div>
              <v-img
                :src="require('@/assets/illustrations/3.svg')"
                width="20vw"
                max-width="50px"
              />
            </div> -->
            <div
              style="
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 10px;
              "
              class="mt-4 mb-10"
            >
              <v-btn
                block
                variant="flat"
                color="smokeDark"
                style="
                  border-radius: 6px;
                  border-left: 1px solid #272727;
                  border-right: 3px solid #272727;
                  border-top: 1px solid #272727;
                  border-bottom: 3px solid #272727;
                "
                @click="
                  $store.dispatch('startNewPost', { category: query.category })
                "
                >Add new post</v-btn
              >
              <v-btn
                block
                variant="flat"
                color="smokeDark"
                style="
                  border-radius: 6px;
                  border-left: 1px solid #272727;
                  border-right: 3px solid #272727;
                  border-top: 1px solid #272727;
                  border-bottom: 3px solid #272727;
                "
                :loading="generating_posts"
                @click="generatePosts"
                ><v-icon size="14" class="mr-2">mdi-creation</v-icon> Generate
                posts</v-btn
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <CategoryManagerPanel
      v-model="showCategoryManager"
      :selected-category="category"
      :categories="categories"
      @close="showCategoryManager = false"
    />

    <div class="mb-4">
      <ConfirmDialog :dialog="confirm_dialog" @confirm="confirm" />

      <div
        class="d-flex justify-space-between"
        v-if="$vuetify.display.smAndDown"
      >
        <h1 class="mb-4">Posts</h1>
        <v-btn
          @click="$router.push('/post')"
          class="mb-4"
          elevation="0"
          color="button"
          >Add new post</v-btn
        >
      </div>
      <div v-if="$vuetify.display.smAndDown">
        <p style="font-size: 10px" class="mb-2">Search</p>
        <div class="d-flex">
          <v-text-field
            style="border-radius: 8px"
            label="Search"
            height="50"
            variant="solo"
            hide-details=""
            flat
            :style="{
              borderBottom: '2px solid #272727',
              borderLeft: '0.75px solid #272727',
              borderTop: '0.75px solid #272727',
              borderRight: '2px solid #272727',
            }"
          ></v-text-field>
          <FilterSheet />
        </div>
      </div>
    </div>

    <div
      v-if="$vuetify.display.smAndDown && posts.length > 0"
      class="cards_mobile"
    >
      <ContentCard v-for="i in posts" :key="i.uid" :item="i" />
      <p style="text-align: center; opacity: 0.6; margin-top: 20px">
        &#128075; That's it!
      </p>
    </div>

    <p
      v-if="posts.length === 0 && $vuetify.display.smAndDown"
      style="text-align: center; opacity: 0.6; margin-top: 20px"
    >
      Whoops! No posts found yet..
    </p>

    <div></div>
  </div>
</template>

<script>
import { doc, deleteDoc, updateDoc } from "firebase/firestore";
import { db } from "@/firebase";
import FilterSheet from "@/components/FilterSheet.vue";
import { mapState } from "vuex";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import ContentCard from "@/components/ContentCard.vue";
import PostsCard from "@/components/post/PostsCard.vue";
import CalendarView from "@/components/calendar/CalendarView.vue";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import SourcesView from "@/components/sources/SourcesView.vue";
import QueueView from "@/components/post/QueueView.vue";
import OrderView from "@/components/post/OrderView.vue";
import CategoryManagerPanel from "@/components/category/CategoryManagerPanel.vue";
import NewCategory from "@/components/NewCategory.vue";
import KeepCategory from "@/components/category/KeepCategory.vue";

export default {
  components: {
    FilterSheet,
    ConfirmDialog,
    ContentCard,
    PostsCard,
    CalendarView,
    SourcesView,
    QueueView,
    OrderView,
    CategoryManagerPanel,
    NewCategory,
    KeepCategory,
  },
  mounted() {
    if (this.$route.query.category) {
      this.query.category = this.$route.query.category;
    }
    if (this.$route.query.recurring) {
      this.query.recurring = this.$route.query.recurring === "true";
    }

    if (this.$route.query.search) {
      this.query.search = this.$route.query.search;
    }
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      loading: (state) => state.loading,
      accounts: (state) => state.accounts.accounts,
      categories: (state) => state.posts.categories,
      posts: (state) => state.posts.posts,
      workspace: (state) => state.workspace.workspace,
    }),
    category() {
      return this.categories.find((c) => c.uid === this.query.category);
    },
    hasSuggestedPosts() {
      return this.filtered_posts.some((p) => p.status === "suggested");
    },
    suggestedCategoriesCount() {
      return (this.categories || []).filter((c) => c.status === "suggested")
        .length;
    },
    filtered_posts() {
      let items = this.posts;

      if (this.query.knowledge?.length > 0 && items.length > 0) {
        items = items.filter((p) => {
          return p.uid && this.query.knowledge.includes(p.uid);
        });
        return items;
      }

      if (this.query.category && items.length > 0) {
        items = items.filter((p) => {
          return p.category && p.category.uid === this.query.category;
        });
      }
      if (this.query.category === null) {
        items = items.filter((p) => {
          return p.category === null;
        });
      }

      if (this.query.search && items.length > 0) {
        items = items.filter((p) => {
          let found = false;
          p.variations.map((v) => {
            if (
              v.text.toLowerCase().includes(this.query.search.toLowerCase())
            ) {
              found = true;
            }
          });
          return found;
        });
      }

      if (this.query.recurring != null && items.length > 0) {
        items = items.filter((p) => {
          return p.recurring === this.query.recurring;
        });
      }

      if (this.query.status != "all") {
        items = items.filter((p) => {
          return p.status === this.query.status;
        });
      }
      return items;
    },
    viewModes() {
      const base = [
        { text: "Grid", icon: "mdi-view-grid-outline", value: "grid" },
        // { text: "Queue", icon: "mdi-tray-full", value: "queue" },
        { text: "Calendar", icon: "mdi-calendar-outline", value: "calendar" },
        { text: "Order", icon: "mdi-reorder-horizontal", value: "order" },
      ];
      if (!this.query.category) {
        return base.filter((m) => m.value !== "queue" && m.value !== "order");
      }
      return base;
    },
    nextWeekDisabled() {
      let disabled =
        this.$store.state.schedules.window ===
        this.$store.state.schedules.calendar.length - 1;

      console.log("nextWeekDisabled", disabled);
      if (disabled) {
        this.$store.dispatch("getCalendarDays");
      }
      return disabled;
    },
    query: {
      get() {
        return this.$store.state.posts.query;
      },
      set(newValue) {
        this.$store.commit("setQuery", newValue);
      },
    },
  },
  data() {
    return {
      confirm_dialog: false,
      colormenu: false,
      filter_channel: null,
      headers: [
        {
          text: "Category",
          value: "category",
          width: "500px",
        },
        { text: "Image", value: "image" },
        {
          text: "Message",
          align: "start",
          value: "message",
        },
        { text: "", value: "details" },

        { text: "Actions", value: "actions" },
      ],
      menu: false,
      mode: "grid",
      recurring_items: [
        {
          text: "Recurring",
          value: true,
        },
        {
          text: "One-time",
          value: false,
        },
      ],
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Drafts", value: "draft" },
        { label: "AI Suggested", value: "suggested" },
        { label: "Active", value: "active" },
      ],
      search: "",
      selected: [],
      show_suggestions: true,
      tab: 0,
      generating_posts: false,
      keepingAll: false,
      shuffling: false,
      showCategoryManager: false,
    };
  },
  methods: {
    getStatusDisplayName(status) {
      const statusOption = this.statusOptions.find((s) => s.value === status);
      return statusOption ? statusOption.label : "All";
    },
    openCategoryManager(focusSuggestions) {
      this.showCategoryManager = true;
      if (focusSuggestions && !this.category && this.categories.length > 0) {
        const firstNonSuggested = this.categories.find(
          (c) => c.status !== "suggested",
        );
        if (firstNonSuggested) {
          this.query.category = firstNonSuggested.uid;
        }
      }
    },
    async keepAllPosts() {
      this.keepingAll = true;
      try {
        const suggestedPosts = this.filtered_posts.filter(
          (p) => p.status === "suggested",
        );
        await Promise.all(
          suggestedPosts.map((post) =>
            updateDoc(
              doc(
                db,
                "workspaces",
                this.userProfile.workspace,
                "posts",
                post.uid,
              ),
              { status: "draft" },
            ),
          ),
        );
        this.$store.dispatch("fetchPosts");
        const postCategory =
          suggestedPosts.find((p) => p.category?.uid)?.category?.uid || null;
        if (this.query.knowledge?.length > 0) {
          this.query.knowledge = [];
        }
        if (postCategory) {
          this.query.category = postCategory;
        }
        this.$store.commit("setNotification", {
          show: true,
          text: "All posts kept as drafts!",
          type: "success",
          icon: "mdi-check-circle",
        });
      } catch (error) {
        console.log("error keeping all posts", error);
        this.$store.commit("setNotification", {
          show: true,
          text: "Error keeping posts",
          type: "error",
          icon: "mdi-alert-circle",
        });
      }
      this.keepingAll = false;
    },
    syncCalendar() {
      this.$store.commit("setLoading", { type: "calendar", val: true });
      this.$store.commit("setEndOfCalendar", false);
      this.$store.commit("setCursor", null);
      this.$store.commit("setCalendar", []);
      this.$store.dispatch("getCalendarDays");
      this.$store.commit("setNotification", {
        show: true,
        text: "Calendar synced successfully!",
        type: "primary",
        icon: "mdi-check",
      });
      this.$store.commit("setLoading", { type: "calendar", val: false });
    },
    async shuffleOrder() {
      this.shuffling = true;
      await this.$refs.orderView?.shuffleAnimated();
      this.shuffling = false;
    },
    async generatePosts(count) {
      this.generating_posts = true;
      let posts = this.filtered_posts.map((p) => {
        return {
          text: p.variations[0].text,
          engagementRate: p.statistics?.engagementRate,
        };
      });

      await this.$store.dispatch("generatePosts", {
        count: count,
        posts: posts,
        category_uid: this.query.category,
      });
      this.generating_posts = false;
      this.$store.commit("setNotification", {
        show: true,
        text: "Posts generated successfully!",
        type: "primary",
        icon: "mdi-check",
      });
    },

    openPost(p) {
      console.log(p);
    },
    clearCategory() {
      delete this.query.category;
      this.$router.replace({
        name: "Posts",
        query: this.query,
      });
    },
    changeCategory(v) {
      if (v) {
        this.query.category = v;
        this.$router.replace({
          name: "Posts",
          query: this.query,
        });
      }
    },
    clearRecurring() {
      delete this.query.recurring;
      this.$router.replace({
        name: "Posts",
        query: this.query,
      });
    },
    changeRecurring(v) {
      if (v != null) {
        this.query.recurring = v;
        this.$router.replace({
          name: "Posts",
          query: this.query,
        });
      }
    },
    clearSearch() {
      delete this.query.search;
      this.$router.replace({
        name: "Posts",
        query: this.query,
      });
    },
    changeSearch(v) {
      if (v) {
        this.query.search = v;
        this.$router.replace({
          name: "Posts",
          query: this.query,
        });
      } else {
        this.clearSearch();
      }
    },
    confirm(v) {
      console.log(v);
      this.confirm_dialog = false;
    },
    deletePost(v) {
      console.log(v);
    },
    deleteSelected() {
      this.selected.forEach(async (i) => {
        await deleteDoc(
          doc(
            db,
            "workspaces",
            this.$store.state.userProfile.workspace,
            "social",
            "content",
            i.category.name,
            i.uid,
          ),
        );
      });
    },
    openLink(url) {
      window.open(url, "_blank");
    },
    select(v) {
      if (this.selected.includes(v)) {
        const ind = this.selected.findIndex((i) => {
          i === v;
        });
        this.selected.splice(ind, 1);
      } else {
        this.selected.push(v);
      }
    },
    async test() {
      console.log("test");
      const test = httpsCallable(functions, "test");
      let res = await test({
        account: this.accounts[0],
        workspace: this.workspace.uid,
      });
      console.log(res.data);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./styles.scss";
</style>
